import React from 'react';

import CostingFields from '@features/costing/components/CostingFields';

import { checkUserType, isValidInput, validateFloatNumber } from '@utils/Util';

const CostingAccordion = ({
	increaseCostField,
	setIncreaseCostField,
	inputValueOfSet = [],
	onSetMemberInputChange,
	submitProcessFromAllCost,
	showMore,
	resetAll,
	setShowMore,
	readOnly,
	updateSetMembersCosting,
	prevTarget,
	renderAiCostButton
}) => {
	const isCostingManager = () => checkUserType('COSTING_MANAGER');

	const renderAccordionHeader = (
		dataTarget,
		areaControll,
		productName,
		productCost = 0,
		isQuoted,
		index
	) => {
		return (
			<div className="card-header p-0" id={areaControll}>
				<h2 className="mb-0">
					<button
						className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
						type="button"
						data-toggle="collapse"
						data-target={dataTarget}
						aria-expanded="true"
						aria-controls={dataTarget}
					>
						<div className="d-flex justify-content-between">
							<h3 className="semibold-14 mb-0">
								{productName}
								{isQuoted && (
									<img
										src={`${process.env.PUBLIC_URL}/icons/completed-icon.svg`}
										alt="completed"
										className="ml-2"
									/>
								)}
							</h3>
							<div className="d-flex align-items-center">
								<p className="regular-14 weight-500">
									${Number(productCost ?? 0).toFixed(2)}
								</p>
								<img
									src={`${process.env.PUBLIC_URL}/icons/down-arrow-dropdown.svg`}
									alt="arrow"
									className="arrow ml-3"
								/>
							</div>
						</div>
					</button>
				</h2>
			</div>
		);
	};
	return (
		<div className="accordion costing-form-accordion" id="accordionExample">
			{inputValueOfSet.map((memberOfSet, index) => (
				<div className="card" key={memberOfSet?.id}>
					{renderAccordionHeader(
						`#collapse${index}`,
						`heading${index}`,
						memberOfSet?.category,
						memberOfSet?.totalCost,
						memberOfSet?.isQuoted,
						index
					)}
					{renderAiCostButton ? renderAiCostButton(memberOfSet?.id) : <></>}
					<div
						id={`collapse${index}`}
						className={`collapse ${index === 0 ? 'show' : ''}`}
						aria-labelledby={`heading${index}`}
						data-parent="#accordionExample"
					>
						<div className="card-body">
							<div className="costing-data">
								<CostingFields
									inputData={memberOfSet}
									increaseCostField={increaseCostField}
									setIncreaseCostField={setIncreaseCostField}
									handleChange={onSetMemberInputChange}
									prevTarget={prevTarget}
									isCostingManager={isCostingManager}
									isValidInput={isValidInput}
									resetAll={resetAll}
									fetchCostInfoFromCostField={(_, memberId) =>
										submitProcessFromAllCost(memberId)
									}
									updateCosting={updateSetMembersCosting}
									showMore={showMore}
									setShowMore={setShowMore}
									validateFloatNumber={validateFloatNumber}
									readOnly={readOnly}
									setMemberId={memberOfSet?.id}
								/>
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default CostingAccordion;
